import { render, staticRenderFns } from "./DnsLookup.vue?vue&type=template&id=2595176b"
import script from "./DnsLookup.vue?vue&type=script&lang=js"
export * from "./DnsLookup.vue?vue&type=script&lang=js"
import style0 from "./DnsLookup.vue?vue&type=style&index=0&id=2595176b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports